import styled from 'styled-components'

export const TextInput = styled.input`
    height: 3rem;
`